import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";


type Props = {
  ddlCentroCusto: DropDown[];
  ddlProjeto: DropDown[];
  ddlSolicitante: DropDown[];
  idsCentroCusto?: number[];
  idsProjeto?: number[];
  statusOptions?: DropDown[];
  statusEmailOptions?: DropDown[];
  idsSolicitante?: number[];
  status?: number;
  statusEmail?: number;
  dataDe?: Date | null;
  dataAte?: Date | null;

  onCentroCustoChange: (v: number[]) => void;
  onProjetoChange: (v: number[]) => void;
  onSolicitanteChange: (v: number[]) => void;
  onStatusChange: (v: number) => void;
  onStatusEmailChange: (v: number) => void;
  onDataChange: (de: Date | null, ate: Date | null) => void;

  onClearFilters: () => void;
};


export const Header = ({
  ddlCentroCusto,
  ddlProjeto,
  ddlSolicitante,
  idsCentroCusto,
  idsProjeto,
  idsSolicitante,
  statusOptions,
  status,
  statusEmail,
  statusEmailOptions,
  dataDe,
  dataAte,
  onCentroCustoChange,
  onProjetoChange,
  onSolicitanteChange,
  onStatusChange,
  onStatusEmailChange,
  onDataChange,
  onClearFilters,
}: Props) => {

  return (
    <CascateList title="Pesquisar" defaultOpen>
      <div className="w-full p-6 flex flex-col gap-6">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <DefaultAutocomplete
            label="Centro de Custo"
            options={ddlCentroCusto}
            value={ddlCentroCusto.find((x) => x.id === idsCentroCusto?.[0]) ?? null}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onCentroCustoChange(x ? [x.id] : [])}
          />

          <DefaultAutocomplete
            label="Projetos"
            options={ddlProjeto}
            value={ddlProjeto.find((x) => x.id === idsProjeto?.[0]) ?? null}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onProjetoChange(x ? [x.id] : [])}
          />

          <DefaultAutocomplete
            label="Solicitante"
            options={ddlSolicitante}
            value={ddlSolicitante.find((x) => x.id === idsSolicitante?.[0]) ?? null}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onSolicitanteChange(x ? [x.id] : [])}
          />

          <DefaultAutocomplete
            label="Status"
            options={statusOptions ?? []}
            value={statusOptions?.find((x) => x.id === status) ?? null}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onStatusChange(x ? x.id : 0)}
          />

          <DefaultAutocomplete
            label="Status Email"
            options={statusEmailOptions ?? []}
            value={statusEmailOptions?.find((x) => x.id === statusEmail) ?? null}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onStatusEmailChange(x ? x.id : 0)}
          />

          <DefaultDateRangePickerInput
            label="Data Solicitação"
            dataDe={dataDe ?? null}
            dataAte={dataAte ?? null}
            onChange={(start, end) => onDataChange(start, end)}
          />

        </div>

        <div className="flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={() => onClearFilters()}>

              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
